//way 1
// $(document).ready(function () {
//   $(".magnetic").each(function () {
//     const $this = $(this);
//     const xTo = gsap.quickTo($this[0], "x", {
//       duration: 1,
//       ease: "elastic.out(1, 0.3)",
//     });
//     const yTo = gsap.quickTo($this[0], "y", {
//       duration: 1,
//       ease: "elastic.out(1, 0.3)",
//     });

//     $this.on("mousemove", function (e) {
//       const { clientX, clientY } = e;
//       const { height, width, left, top } = $this[0].getBoundingClientRect();
//       const x = clientX - (left + width / 2);
//       // //6,7,-15etc
//       // console.log(x);
//       const y = clientY - (top + height / 2);
//       xTo(x * 0.35);
//       yTo(y * 0.35);
//     });

//     $this.on("mouseleave", function () {
//       xTo(0);
//       yTo(0);
//     });
//   });
// });

/**
 * Magnetic Buttons
 */
function initMagneticButtons() {
  var magnets = document.querySelectorAll(".another-magnetic");
  var strength = 100;

  // START : If screen is bigger as 540 px do magnetic
  if (window.innerWidth > 540) {
    // Mouse Reset
    magnets.forEach((magnet) => {
      magnet.addEventListener("mousemove", moveMagnet);
      magnet.addEventListener("mouseleave", function (event) {
        console.log(event.currentTarget);
        gsap.to(event.currentTarget, 1.5, {
          x: 0,
          y: 0,
          ease: Elastic.easeOut,
        });
        gsap.to($(this).find(".btn-text"), 1.5, {
          x: 0,
          y: 0,
          ease: Elastic.easeOut,
        });
      });
    });

    // Mouse move
    function moveMagnet(event) {
      var magnetButton = event.currentTarget;
      console.log(magnetButton);
      var bounding = magnetButton.getBoundingClientRect();
      var magnetsStrength = magnetButton.getAttribute("data-strength");
      var magnetsStrengthText = magnetButton.getAttribute("data-strength-text");

      gsap.to(magnetButton, 1.5, {
        x:
          ((event.clientX - bounding.left) / magnetButton.offsetWidth - 0.5) *
          magnetsStrength,
        y:
          ((event.clientY - bounding.top) / magnetButton.offsetHeight - 0.5) *
          magnetsStrength,
        rotate: "0.001deg",
        ease: Power4.easeOut,
      });
      gsap.to($(this).find(".btn-text"), 1.5, {
        x:
          ((event.clientX - bounding.left) / magnetButton.offsetWidth - 0.5) *
          magnetsStrengthText,
        y:
          ((event.clientY - bounding.top) / magnetButton.offsetHeight - 0.5) *
          magnetsStrengthText,
        rotate: "0.001deg",
        ease: Power4.easeOut,
      });
    }
  } // END : If screen is bigger as 540 px do magnetic
}
initMagneticButtons();

// mobile menu
// way 1 using css

// $(".menu-button").on("click", function () {
//   $(".burger-icon").toggleClass("burger-active");
//   $(".fixed-nav").toggleClass("open");
//   $(".links-wrap li").removeClass("slide");
//   if ($(".fixed-nav").hasClass("open")) {
//     $(".links-wrap li").each(function (index) {
//       var $this = $(this);
//       setTimeout(function () {
//         $this.addClass("animate");
//       }, index * 100); // Delay of 100ms per item
//     });
//   } else {
//     $(".links-wrap li").each(function () {
//       $(this).removeClass("animate").css({
//         transform: "translateX(80px)",
//         opacity: 0,
//       });
//     });
//   }
// });

//way 2 using gsap
$(document).ready(function () {
  const windowHeight = $(window).height();

  //Q-100 curve control on far left exceeding
  //Q100 curve control on far right - no curve
  //Q-0 curve control on left initial
  const initialPath = `M100 0 L200 0 L200 ${windowHeight} L100 ${windowHeight} Q-100 ${
    windowHeight / 2
  } 100 0`;
  const targetPath = `M100 0 L200 0 L200 ${windowHeight} L100 ${windowHeight} Q100 ${
    windowHeight / 2
  } 100 0`;

  // const initialPath = `M100 0 L100 ${window.innerHeight} Q-100 ${
  //   window.innerHeight / 2
  // } 100 0`;
  // const targetPath = `M100 0 L100 ${window.innerHeight} Q100 ${
  //   window.innerHeight / 2
  // } 100 0`;

  $("#animatedPath").attr("d", initialPath);

  function animatePath(toTarget) {
    const path = toTarget ? targetPath : initialPath;
    gsap.to("#animatedPath", {
      duration: 1,
      attr: { d: path },
      ease: "power1.inOut",
      onComplete: function () {
        console.log("SVG animation completed");
      },
    });
  }

  $(".menu-button").on("click", function () {
    $(".burger-icon").toggleClass("burger-active");
    $(".fixed-nav").toggleClass("open");
    $(".links-wrap li").removeClass("slide");
    if ($(".fixed-nav").hasClass("open")) {
      $("body").css("overflow", "hidden");
      gsap.to(".links-wrap li", {
        duration: 0.8,
        x: 0,
        opacity: 1,
        stagger: 0.2,
        ease: "power1.out",
      });
      animatePath(true);
    } else {
      $("body").css("overflow", "");
      gsap.to(".links-wrap li", {
        duration: 0.8,
        x: 80,
        opacity: 0,
        stagger: 0.2,
        ease: "power1.in",
      });
      animatePath(false);
    }
  });

  // Smooth scroll on anchor click
  $('a[href^="#"]').on("click", function (e) {
    e.preventDefault();

    const target = $(this.getAttribute("href"));
    if (target.length) {
      // Close mobile menu if this link is inside mobile-menu
      if ($(this).closest(".mobile-menu").length) {
        $(".fixed-nav").removeClass("open");
        $(".burger-icon").removeClass("burger-active");
        $("body").css("overflow", "");
        gsap.to(".links-wrap li", {
          duration: 0.4,
          x: 80,
          opacity: 0,
          ease: "power1.in",
        });
        animatePath(false);
      }
      $("html, body").animate(
        {
          scrollTop: target.offset().top,
        },
        800
      );
    }
  });

  // Smooth scroll if page loads with a hash in the URL
  if (window.location.hash) {
    const target = $(window.location.hash);
    if (target.length) {
      setTimeout(() => {
        $("html, body").animate(
          {
            scrollTop: target.offset().top,
          },
          800
        );
      }, 800); // small delay ensures layout is ready
    }
  }
});
